import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { start as startCookieBannerDetection } from "@eyeo-fragments/cookie-banner-detection/background";
import { start as startFilterExperiments } from "@eyeo-fragments/filter-experiments/background";
import { Prefs } from "~/alias/prefs";
import { start as startSettings } from "~/prefs/background";
import * as logger from "~/utilities/background";
import { start as startInProductMessaging } from "../../ipm/background";
import { start as startGrowthExperiments } from "../../growth-experiments/background";
import { start as startNewTab } from "../../../adblock-betafish/new-tab/background";
import { start as startOnPageDialog } from "../../../adblock-betafish/onpage-dialog/background";
import { start as startTelemetry } from "../../telemetry/background";
import { start as startTestingEwe } from "../../testing/ewe/background";
async function bootstrapAsync() {
    try {
        startCookieBannerDetection();
        startTestingEwe();
        await Promise.all([
            startFilterExperiments(),
            startInProductMessaging(),
            startNewTab(),
            startOnPageDialog(),
            startTelemetry(),
        ]);
    }
    catch (ex) {
        logger.reportAndLogError(ex);
    }
}
function bootstrapSync() {
    if (Prefs.get("data_collection_opt_out")) {
        console.warn("Sentry is not initialized");
    }
    else {
        void ewe.sentry.start(webpackDotenvPlugin.SENTRY_DSN, webpackDotenvPlugin.SENTRY_ENVIRONMENT, info.addonVersion);
    }
}
async function bootstrap() {
    bootstrapSync();
    startSettings();
    void startGrowthExperiments();
    await bootstrapAsync();
}
void bootstrap();
